import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class PeaPatchBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.PEA_PATCH;
}

export default PeaPatchBuildingTileEntity;
